import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSettings } from "./redux/storesSagas";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { WindowVirtualList } from "../../../components/WindowVirtualList/WindowVirtualList";
import { StoreRow } from "./smartComponents/StoreRow";
import { usePopup } from "../../../hooks/usePopup";
import { Edit } from "./smartComponents/Edit";
import { Add } from "./smartComponents/Add";
import { Delete } from "./smartComponents/Delete";
import { Recalculate } from "./smartComponents/Recalculate";
import { storesApi } from "./api";
import { requestWithDownload } from "../../../utils/request";

function prepareListItems(stores, searchValue) {
  const rows = [];
  if (!stores) return rows;

  Object.entries(stores).forEach(([orgName, storeList]) => {
    const filteredStores = !searchValue
      ? storeList
      : storeList.filter((store) => store.name.toLowerCase().includes(searchValue));

    if (filteredStores.length > 0) {
      rows.push({ type: "header", orgName });
      filteredStores.forEach((store) => {
        rows.push({ type: "store", orgName, store });
      });
    }
  });
  return rows;
}

export const StoresModule = ({ params }) => {
  const dispatch = useDispatch();
  const stores = useSelector((state) => state.stores.stores);
  const areStoresLoading = useSelector((state) => state.stores.areStoresLoading);
  const { popup, openPopup, closePopup } = usePopup(["edit", "delete", "confirm"]);
  const [selectedStore, setSelectedStore] = useState("");

  const handlePopup = (item, type) => {
    setSelectedStore(item);

    openPopup(type);
  };

  useEffect(() => {
    dispatch(fetchSettings(params));
  }, []);

  const onMenuItemClick = ({ value, syntheticEvent }, item) => {
    if (!value) return;

    setSelectedStore(item.store);
    syntheticEvent.preventDefault();

    openPopup(value);
  };

  const exportActive = () => {
    requestWithDownload(storesApi.exportActiveStores, "active_stores");
  };

  return (
    <div id="stores">
      <div className="stores">
        {areStoresLoading ? (
          <LoadingAnimation />
        ) : (
          <>
            <div className="stores__top">
              <button onClick={() => openPopup("add")} className="button button--primary">
                Add New
              </button>

              <button onClick={exportActive} className="button button--primary">
                Export Active
              </button>
            </div>

            <div className="stores__content">
              <ul className="group">
                {stores && Object.keys(stores).length ? (
                  <WindowVirtualList
                    rawItems={stores}
                    processItemsFn={prepareListItems}
                    estimateSize={() => 40}
                    renderRow={({ item }) => (
                      <StoreRow
                        item={item}
                        onMenuItemClick={onMenuItemClick}
                        handlePopup={handlePopup}
                      />
                    )}
                  />
                ) : null}
              </ul>
            </div>
          </>
        )}

        {popup.edit && (
          <Edit isOpen={popup.edit} onClose={closePopup("edit")} selected={selectedStore} />
        )}
        {popup.add && (
          <Add isOpen={popup.add} onClose={closePopup("add")} selected={selectedStore} />
        )}
        {popup.delete && (
          <Delete isOpen={popup.delete} onClose={closePopup("delete")} selected={selectedStore} />
        )}
        {popup.reimportRecalculate && (
          <Recalculate
            isOpen={popup.reimportRecalculate}
            onClose={closePopup("reimportRecalculate")}
            reimport
            selected={selectedStore}
          />
        )}
        {popup.recalculate && (
          <Recalculate
            isOpen={popup.recalculate}
            onClose={closePopup("recalculate")}
            selected={selectedStore}
          />
        )}
      </div>
    </div>
  );
};
